import { tickerItems } from '@/mocks/gossip';

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section id="ticker" className="w-full bg-foreground-950 border-b border-foreground-800">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-stretch gap-3 md:gap-4 h-14">
          <div className="flex items-center gap-2 shrink-0 pr-3 md:pr-4 border-r border-foreground-700">
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-live-line text-xs" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-base md:text-lg text-background-50 whitespace-nowrap">今日爆料速递</span>
          </div>

          <div className="relative flex-1 overflow-hidden flex items-center">
            <div className="flex items-center gap-8 whitespace-nowrap animate-marquee will-change-transform">
              {loop.map((item, index) => (
                <span key={`${item.id}-${index}`} className="flex items-center gap-2 text-xs md:text-sm font-body">
                  <i className="ri-flashlight-fill text-accent-400" aria-hidden="true"></i>
                  <span className="text-background-100/90">{item.text}</span>
                  <span className="text-foreground-500 font-label">{item.time}</span>
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-foreground-950 to-transparent"></div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-foreground-950 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}